// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { isNodeSelection } from '@tiptap/react';

// // --- Hooks ---

// // --- Icons ---

// // --- Lib ---

// // --- UI Primitives ---

// // import { Popover, PopoverContent, PopoverTrigger } from '@/components/tiptap-ui-primitive/popover';

// // --- Styles ---
// import '../bounties/link-popover.css';
// import { useTiptapEditor } from '../../hooks/useTiptapEditor';
// import { isMarkInSchema } from '../../hooks/isMarkInSchema';
// import { Popover, PopoverContent, PopoverTrigger } from './PopOver';
// import { Link as LinkIcon } from 'lucide-react';

// // LinkHandler Hook

// const buttonClass = `
//     inline-flex items-center justify-center
//     w-9 h-9 rounded-md
//     text-gray-700 hover:text-blue-600
//     bg-grayBgNormal hover:bg-blue-50
//     border border-gray-200 hover:border-blue-300
//     transition-all duration-200 ease-in-out
//     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
//     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-grayBgNormal disabled:hover:text-gray-700 disabled:hover:border-gray-200
//   `;

// const activeButtonClass = `

//         inline-flex items-center justify-center
//     w-9 h-9 rounded-md

//      hover:bg-blue-50
//     border
//     transition-all duration-200 ease-in-out
//     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
//     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-grayBgNormal disabled:hover:text-gray-700 disabled:hover:border-gray-200

//     bg-blue-600 text-white border-blue-600
//     hover:bg-blue-700 hover:border-blue-700 hover:text-white
//   `;

// const CornerDownLeftIcon = ({ className = '', ...props }) => {
//     return (
//         <svg
//             width="24"
//             height="24"
//             className={className}
//             viewBox="0 0 24 24"
//             fill="currentColor"
//             xmlns="http://www.w3.org/2000/svg"
//             {...props}
//         >
//             <path
//                 fillRule="evenodd"
//                 clipRule="evenodd"
//                 d="M21 4C21 3.44772 20.5523 3 20 3C19.4477 3 19 3.44772 19 4V11C19 11.7956 18.6839 12.5587 18.1213 13.1213C17.5587 13.6839 16.7956 14 16 14H6.41421L9.70711 10.7071C10.0976 10.3166 10.0976 9.68342 9.70711 9.29289C9.31658 8.90237 8.68342 8.90237 8.29289 9.29289L3.29289 14.2929C2.90237 14.6834 2.90237 15.3166 3.29289 15.7071L8.29289 20.7071C8.68342 21.0976 9.31658 21.0976 9.70711 20.7071C10.0976 20.3166 10.0976 19.6834 9.70711 19.2929L6.41421 16H16C17.3261 16 18.5979 15.4732 19.5355 14.5355C20.4732 13.5979 21 12.3261 21 11V4Z"
//                 fill="currentColor"
//             />
//         </svg>
//     );
// };

// const ExternalLinkIcon = ({ className = '', ...props }) => {
//     return (
//         <svg
//             width="24"
//             height="24"
//             className={className}
//             viewBox="0 0 24 24"
//             fill="currentColor"
//             xmlns="http://www.w3.org/2000/svg"
//             {...props}
//         >
//             <path
//                 d="M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.41421L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L18.5858 4H15C14.4477 4 14 3.55228 14 3Z"
//                 fill="currentColor"
//             />
//             <path
//                 d="M4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V19C2 19.7957 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H16C16.7957 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7957 19 19V13C19 12.4477 18.5523 12 18 12C17.4477 12 17 12.4477 17 13V19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V8C4 7.73478 4.10536 7.48043 4.29289 7.29289Z"
//                 fill="currentColor"
//             />
//         </svg>
//     );
// };

// const TrashIcon = ({ className = '', ...props }) => {
//     return (
//         <svg
//             width="24"
//             height="24"
//             className={className}
//             viewBox="0 0 24 24"
//             fill="currentColor"
//             xmlns="http://www.w3.org/2000/svg"
//             {...props}
//         >
//             <path
//                 fillRule="evenodd"
//                 clipRule="evenodd"
//                 d="M7 5V4C7 3.17477 7.40255 2.43324 7.91789 1.91789C8.43324 1.40255 9.17477 1 10 1H14C14.8252 1 15.5668 1.40255 16.0821 1.91789C16.5975 2.43324 17 3.17477 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V20C20 20.8252 19.5975 21.5668 19.0821 22.0821C18.5668 22.5975 17.8252 23 17 23H7C6.17477 23 5.43324 22.5975 4.91789 22.0821C4.40255 21.5668 4 20.8252 4 20V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7ZM9 4C9 3.82523 9.09745 3.56676 9.33211 3.33211C9.56676 3.09745 9.82523 3 10 3H14C14.1748 3 14.4332 3.09745 14.6679 3.33211C14.9025 3.56676 15 3.82523 15 4V5H9V4ZM6 7V20C6 20.1748 6.09745 20.4332 6.33211 20.6679C6.56676 20.9025 6.82523 21 7 21H17C17.1748 21 17.4332 20.9025 17.6679 20.6679C17.9025 20.4332 18 20.1748 18 20V7H6Z"
//                 fill="currentColor"
//             />
//         </svg>
//     );
// };

// export const useLinkHandler = (props) => {
//     const { editor, onSetLink, onLinkActive } = props;
//     const [url, setUrl] = useState('');

//     useEffect(() => {
//         if (!editor) return;

//         const { href } = editor.getAttributes('link');

//         if (editor.isActive('link') && !url) {
//             setUrl(href || '');
//             onLinkActive?.();
//         }
//     }, [editor, onLinkActive, url]);

//     useEffect(() => {
//         if (!editor) return;

//         const updateLinkState = () => {
//             const { href } = editor.getAttributes('link');
//             setUrl(href || '');

//             if (editor.isActive('link') && !url) {
//                 onLinkActive?.();
//             }
//         };

//         editor.on('selectionUpdate', updateLinkState);
//         return () => {
//             editor.off('selectionUpdate', updateLinkState);
//         };
//     }, [editor, onLinkActive, url]);

//     const setLink = useCallback(() => {
//         if (!url || !editor) return;

//         const { from, to } = editor.state.selection;
//         const text = editor.state.doc.textBetween(from, to);

//         editor
//             .chain()
//             .focus()
//             .extendMarkRange('link')
//             .insertContent({
//                 type: 'text',
//                 text: text || url,
//                 marks: [{ type: 'link', attrs: { href: url } }],
//             })
//             .run();

//         onSetLink?.();
//     }, [editor, onSetLink, url]);

//     const removeLink = useCallback(() => {
//         if (!editor) return;
//         editor.chain().focus().unsetMark('link', { extendEmptyMarkRange: true }).setMeta('preventAutolink', true).run();
//         setUrl('');
//     }, [editor]);

//     return {
//         url,
//         setUrl,
//         setLink,
//         removeLink,
//         isActive: editor?.isActive('link') || false,
//     };
// };

// // LinkButton Component
// export const LinkButton = React.forwardRef(({ className, isOpen, children, ...props }, ref) => {
//     console.log(isOpen, 'see the link style');

//     return (
//         <button
//             type="button"
//             className={`${isOpen ? activeButtonClass : buttonClass}`}
//             title="Strikethrough"
//             data-style="ghost"
//             role="button"
//             tabIndex={-1}
//             aria-label="Link"
//             tooltip="Link"
//             ref={ref}
//             {...props}
//         >
//             {children || <LinkIcon size={16} />}
//         </button>
//     );
// });

// // LinkContent Component
// export const LinkContent = ({ editor: providedEditor }) => {
//     const editor = useTiptapEditor(providedEditor);

//     const linkHandler = useLinkHandler({
//         editor: editor,
//     });

//     return <LinkMain {...linkHandler} />;
// };

// // LinkMain Component
// const LinkMain = ({ url, setUrl, setLink, removeLink, isActive }) => {
//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter') {
//             event.preventDefault();
//             setLink();
//         }
//     };

//     return (
//         <div className="">
//             <div>
//                 <input
//                     type="url"
//                     placeholder="Paste a link..."
//                     value={url}
//                     onChange={(e) => setUrl(e.target.value)}
//                     onKeyDown={handleKeyDown}
//                     autoComplete="off"
//                     autoCorrect="off"
//                     autoCapitalize="off"
//                     className="tiptap-input tiptap-input-clamp"
//                 />

//                 <div className="tiptap-button-group" data-orientation="horizontal">
//                     <button
//                         type="button"
//                         onClick={setLink}
//                         title="Apply link"
//                         disabled={!url && !isActive}
//                         data-style="ghost"
//                     >
//                         <CornerDownLeftIcon className="tiptap-button-icon" />
//                     </button>
//                 </div>

//                 <div>seprator</div>

//                 <div className="tiptap-button-group" data-orientation="horizontal">
//                     <button
//                         type="button"
//                         onClick={() => window.open(url, '_blank')}
//                         title="Open in new window"
//                         disabled={!url && !isActive}
//                         data-style="ghost"
//                     >
//                         <ExternalLinkIcon className="tiptap-button-icon" />
//                     </button>

//                     <button
//                         type="button"
//                         onClick={removeLink}
//                         title="Remove link"
//                         disabled={!url && !isActive}
//                         data-style="ghost"
//                     >
//                         <TrashIcon className="tiptap-button-icon" />
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // LinkPopover Component
// export function LinkPopover({
//     editor: providedEditor,
//     hideWhenUnavailable = false,
//     onOpenChange,
//     autoOpenOnLinkActive = true,
//     ...props
// }) {
//     const editor = useTiptapEditor(providedEditor);

//     const linkInSchema = isMarkInSchema('link', editor);

//     const [isOpen, setIsOpen] = useState(false);

//     const onSetLink = () => {
//         setIsOpen(false);
//     };

//     const onLinkActive = () => setIsOpen(autoOpenOnLinkActive);

//     const linkHandler = useLinkHandler({
//         editor: editor,
//         onSetLink,
//         onLinkActive,
//     });

//     const isDisabled = useMemo(() => {
//         if (!editor) return true;
//         if (editor.isActive('codeBlock')) return true;
//         return !editor.can().setLink?.({ href: '' });
//     }, [editor]);

//     const canSetLink = useMemo(() => {
//         if (!editor) return false;
//         try {
//             return editor.can().setMark('link');
//         } catch {
//             return false;
//         }
//     }, [editor]);

//     const isActive = editor?.isActive('link') ?? false;

//     const handleOnOpenChange = useCallback(
//         (nextIsOpen) => {
//             setIsOpen(nextIsOpen);
//             onOpenChange?.(nextIsOpen);
//         },
//         [onOpenChange]
//     );

//     const show = useMemo(() => {
//         if (!linkInSchema || !editor) {
//             return false;
//         }

//         if (hideWhenUnavailable) {
//             if (isNodeSelection(editor.state.selection) || !canSetLink) {
//                 return false;
//             }
//         }

//         return true;
//     }, [linkInSchema, hideWhenUnavailable, editor, canSetLink]);

//     if (!show || !editor || !editor.isEditable) {
//         return null;
//     }

//     console.log('see the link style', isOpen, isActive, isDisabled, show, linkInSchema);

//     return (
//         <Popover open={isOpen} onOpenChange={handleOnOpenChange}>
//             <PopoverTrigger asChild>
//                 <LinkButton
//                     isOpen={isOpen}
//                     disabled={isDisabled}
//                     data-active-state={isActive ? 'on' : 'off'}
//                     data-disabled={isDisabled}
//                     {...props}
//                 />
//             </PopoverTrigger>

//             <PopoverContent>
//                 <LinkMain {...linkHandler} />
//             </PopoverContent>
//         </Popover>
//     );
// }

// LinkButton.displayName = 'LinkButton';

import React, { useState, useRef, useEffect } from 'react';
import { Link as LinkIcon, ExternalLink, RotateCcw, Trash2 } from 'lucide-react';

export const LinkPopover = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [url, setUrl] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const popoverRef = useRef(null);
    const inputRef = useRef(null);

    const buttonClass = `
    inline-flex items-center justify-center
    w-8 h-8 rounded-md
    text-textSecondary hover:text-textPrimary
    bg-grayBgNormal hover:bg-grayBgDark
    border border-borderUnderline
    transition-all duration-150 ease-in-out
    focus:outline-none focus:ring-2 focus:ring-blueNormal focus:ring-offset-0
  `;

    const activeButtonClass = `
    bg-blueNormal text-hardLight border border-blueNormal
    hover:bg-blueNormalHover hover:border-blueNormalHover
    shadow-sm
  `;

    const isLinkActive = editor.isActive('link');

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setIsOpen(false);
                setIsEditing(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isEditing]);

    // Listen for editor selection changes to auto-open popover when clicking on links
    useEffect(() => {
        const handleSelectionUpdate = () => {
            if (editor.isActive('link') && !isOpen) {
                const selection = editor.state.selection;
                // Only auto-open if cursor is inside a link (not just selecting link text)
                if (selection.empty) {
                    setIsOpen(true);
                    setUrl(editor.getAttributes('link').href || '');
                }
            }
        };

        if (editor) {
            editor.on('selectionUpdate', handleSelectionUpdate);
            return () => {
                editor.off('selectionUpdate', handleSelectionUpdate);
            };
        }
    }, [editor, isOpen]);

    const handleSetLink = () => {
        if (url) {
            // If no text is selected, insert the URL as both text and link
            const { from, to } = editor.state.selection;
            if (from === to) {
                editor.chain().focus().insertContent(`<a href="${url}">${url}</a>`).run();
            } else {
                editor.chain().focus().setLink({ href: url }).run();
            }
        } else {
            editor.chain().focus().unsetLink().run();
        }
        setUrl('');
        setIsOpen(false);
        setIsEditing(false);
    };

    const handleUnsetLink = () => {
        editor.chain().focus().unsetLink().run();
        setIsOpen(false);
        setIsEditing(false);
    };

    const handleOpenLink = () => {
        const href = editor.getAttributes('link').href;
        if (href) {
            window.open(href, '_blank');
        }
    };

    const handleButtonClick = () => {
        if (isLinkActive) {
            setIsOpen(!isOpen);
            if (!isOpen) {
                setUrl(editor.getAttributes('link').href || '');
            }
        } else {
            const { from, to } = editor.state.selection;
            if (from === to) {
                // No text selected - show input to add both text and link
                setIsOpen(true);
                setIsEditing(true);
                setUrl('');
            } else {
                // Text is selected - show input to add link to selected text
                setIsOpen(true);
                setIsEditing(true);
                setUrl('');
            }
        }
    };

    return (
        <div className="relative" ref={popoverRef}>
            <button
                type="button"
                onClick={handleButtonClick}
                className={`${buttonClass} ${isLinkActive ? activeButtonClass : ''}`}
                title={isLinkActive ? 'Edit Link' : 'Add Link'}
            >
                <LinkIcon size={14} />
            </button>

            {isOpen && (
                <div className="absolute top-full left-0 mt-2 bg-grayBgNormal border border-borderUnderline rounded-lg shadow-lg z-50 min-w-[320px]">
                    {isLinkActive && !isEditing ? (
                        <div className="p-1">
                            <div className="flex items-center gap-2 ">
                                <input
                                    type="text"
                                    value={editor.getAttributes('link').href || ''}
                                    readOnly
                                    className="flex-1 px-3 py-1 text-sm bg-grayBgNormal border border-borderUnderline rounded-md text-textSecondary"
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        setIsEditing(true);
                                        setUrl(editor.getAttributes('link').href || '');
                                    }}
                                    className="inline-flex items-center justify-center w-8 h-8 text-textSecondary hover:text-textPrimary hover:bg-grayBgDark rounded transition-colors"
                                    title="Edit"
                                >
                                    <RotateCcw size={14} />
                                </button>
                                <button
                                    type="button"
                                    onClick={handleOpenLink}
                                    className="inline-flex items-center justify-center w-8 h-8 text-textSecondary hover:text-textPrimary hover:bg-grayBgDark rounded transition-colors"
                                    title="Open link"
                                >
                                    <ExternalLink size={14} />
                                </button>
                                <button
                                    type="button"
                                    onClick={handleUnsetLink}
                                    className="inline-flex items-center justify-center w-8 h-8 text-textSecondary hover:text-redBrand6 hover:bg-redBrand4/10 rounded transition-colors"
                                    title="Remove link"
                                >
                                    <Trash2 size={14} />
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="p-3">
                            <div className="flex items-center gap-2">
                                <input
                                    ref={inputRef}
                                    type="url"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                    placeholder="Paste a link..."
                                    className="flex-1 px-3 py-1 text-sm border border-borderUnderline rounded-md bg-grayBgNormal text-textPrimary placeholder:text-textTertiary focus:outline-none focus:ring-2 focus:ring-blueNormal focus:border-blueNormal"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            handleSetLink();
                                        } else if (e.key === 'Escape') {
                                            setIsOpen(false);
                                            setIsEditing(false);
                                        }
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        setIsOpen(false);
                                        setIsEditing(false);
                                        setUrl('');
                                    }}
                                    className="inline-flex items-center justify-center w-8 h-8 text-textSecondary hover:text-textPrimary hover:bg-grayBgDark rounded transition-colors"
                                    title="Cancel"
                                >
                                    <RotateCcw size={14} />
                                </button>
                                <button
                                    type="button"
                                    onClick={handleOpenLink}
                                    className="inline-flex items-center justify-center w-8 h-8 text-textSecondary hover:text-textPrimary hover:bg-grayBgDark rounded transition-colors"
                                    title="Open link"
                                >
                                    <ExternalLink size={14} />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
